import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://nakshacart.com";
const DEFAULT_TITLE = "NakshaCart | Get Your House Plan in 2 Minutes";
const DEFAULT_DESCRIPTION = "NakshaCart — Get your house plan, BOQ and construction cost estimate in 2 minutes. Verified architects & contractors across India. A brand of MECHACIV Construction Pvt Ltd.";

export default function SEO({ title, description, path = "/", image, noindex = false }) {
  const fullTitle = title ? `${title} | NakshaCart` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESCRIPTION;
  const canonical = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
      {noindex && <meta name="robots" content="noindex,nofollow" />}
    </Helmet>
  );
}
